import { createContext } from "react";

const contractContext = createContext();

export default contractContext;